var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-content profile-content__egrn" }, [
    _c(
      "div",
      {
        staticClass: "profile-content-menu",
        staticStyle: { "font-weight": "400" },
      },
      [
        _c(
          "p",
          {
            staticClass: "profile-egrn-status-legend",
            on: {
              click: function ($event) {
                _vm.egrnStatusHelper = !_vm.egrnStatusHelper
              },
            },
          },
          [_vm._v("Расшифровка статуса")]
        ),
        _vm._v(" "),
        _vm.egrnStatusHelper
          ? _c("ul", [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("table", { staticClass: "simple-table desktop" }, [
      _vm._m(6),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.data, function (e, i) {
          return _c("tr", { key: i, staticClass: "simple-table-body-item" }, [
            _c("td", [
              e.type == 1
                ? _c("i", {
                    staticClass: "uk-icon-file-text",
                    attrs: { title: "Обычная выписка" },
                  })
                : e.type == 2
                ? _c("i", {
                    staticClass: "uk-icon-file-text-o",
                    attrs: { title: "Архивная выписка" },
                  })
                : e.type == 3
                ? _c("i", {
                    staticClass: "uk-icon-file",
                    attrs: { title: "Обычная выписка с ЭЦП" },
                  })
                : e.type == 4
                ? _c("i", {
                    staticClass: "uk-icon-file-o",
                    attrs: { title: "Архивная выписка с ЭЦП" },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(new Date(e.datetime).toLocaleDateString())),
            ]),
            _vm._v(" "),
            _c("td", [
              e.kad_num ? _c("span", [_vm._v(_vm._s(e.kad_num))]) : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "simple-table-body-item-title" }, [
              e.address ? _c("span", [_vm._v(_vm._s(e.address))]) : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "simple-table-body-item-status",
                staticStyle: { color: "#444" },
              },
              [
                e.status == 0
                  ? _c("i", {
                      staticClass: "lnr lnr-sync",
                      attrs: { title: "Выписка заказана (в обработке)" },
                    })
                  : e.status == 1
                  ? _c("a", { attrs: { href: e.file_url, target: "_blank" } }, [
                      _c("i", { staticClass: "lnr lnr-download" }),
                    ])
                  : e.status == 2
                  ? _c("i", {
                      staticClass: "lnr lnr-plus-circle",
                      attrs: { title: "Выписка заказана" },
                    })
                  : e.status == 3
                  ? _c("i", {
                      staticClass: "lnr lnr-question-circle",
                      attrs: { title: "Неверный кад. номер" },
                    })
                  : e.status == 4
                  ? _c("i", {
                      staticClass: "lnr lnr-circle-minus",
                      attrs: { title: "Нет данных в Росреестре" },
                    })
                  : _vm._e(),
              ]
            ),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "simple-table mobile" }, [
      _vm._m(7),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.data, function (e, i) {
          return _c("tr", { key: i, staticClass: "simple-table-body-item" }, [
            _c(
              "td",
              {
                staticClass: "simple-table-body-item-status",
                staticStyle: { color: "#444" },
              },
              [
                e.status == 0
                  ? _c("i", {
                      staticClass: "lnr lnr-sync",
                      attrs: { title: "Выписка заказана (в обработке)" },
                    })
                  : e.status == 1
                  ? _c("a", { attrs: { href: e.file_url, target: "_blank" } }, [
                      _c("i", { staticClass: "lnr lnr-download" }),
                    ])
                  : e.status == 2
                  ? _c("i", {
                      staticClass: "lnr lnr-plus-circle",
                      attrs: { title: "Выписка заказана" },
                    })
                  : e.status == 3
                  ? _c("i", {
                      staticClass: "lnr lnr-question-circle",
                      attrs: { title: "Неверный кад. номер" },
                    })
                  : e.status == 4
                  ? _c("i", {
                      staticClass: "lnr lnr-circle-minus",
                      attrs: { title: "Нет данных в Росреестре" },
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("td", [
              e.kad_num ? _c("span", [_vm._v(_vm._s(e.kad_num))]) : _vm._e(),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", {
        staticClass: "lnr lnr-sync",
        attrs: { title: "Выписка заказана (в обработке)" },
      }),
      _vm._v(" - Выписка заказана (в обработке)"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "lnr lnr-download" }),
      _vm._v(" - Выписка готова, можно скачать"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", {
        staticClass: "lnr lnr-checkmark-circle",
        attrs: { title: "Выписка готова и отправлена" },
      }),
      _vm._v(" - Выписка готова и отправлена"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", {
        staticClass: "lnr lnr-plus-circle",
        attrs: { title: "Выписка заказана" },
      }),
      _vm._v(" - Выписка заказана"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", {
        staticClass: "lnr lnr-question-circle",
        attrs: { title: "Неверный кад. номер" },
      }),
      _vm._v(" - Неверный кад. номер"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", {
        staticClass: "lnr lnr-circle-minus",
        attrs: { title: "Нет данных в Росреестре" },
      }),
      _vm._v(" - Нет данных в Росреестре"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "white-space": "nowrap" } }, [
          _vm._v("Кадастровый номер"),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Статус")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Статус"),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "white-space": "nowrap" } }, [
          _vm._v("Кадастровый номер"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }